// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTOneDrive,
    RESTOneDriveFolder,
} from './';

/**
 * @export
 * @interface RESTCopyToFolders
 */
export interface RESTCopyToFolders {
    /**
     * Specifies IDs of the OneDrive folders that you want to copy. For more information on how to get such IDs, see [Get OneDrive Folders](#tag/OneDriveFolder/operation/OneDriveFolder_Get).
     * @type {Array<RESTOneDriveFolder>}
     * @memberof RESTCopyToFolders
     */
    folders?: Array<RESTOneDriveFolder>;
    /**
     * Defines whether all versions of OneDrive items will be copied.
     * @type {boolean}
     * @memberof RESTCopyToFolders
     */
    changedItems?: boolean | null;
    /**
     * Defines whether the deleted OneDrive items will be copied.
     * @type {boolean}
     * @memberof RESTCopyToFolders
     */
    deletedItems?: boolean | null;
    /**
     * Defines whether the OneDrive items will be copied with all permissions.
     * @type {boolean}
     * @memberof RESTCopyToFolders
     */
    restorePermissions?: boolean;
    /**
     * Defines whether the shared links notifications will be sent.
     * @type {boolean}
     * @memberof RESTCopyToFolders
     */
    sendSharedLinksNotification?: boolean | null;
    /**
     * @type {RESTOneDrive}
     * @memberof RESTCopyToFolders
     */
    onedrive?: RESTOneDrive;
    /**
     * Specifies the target folder for the copied OneDrive folders.
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    folder?: string;
    /**
     * Specifies what version of the OneDrive documents will be copied.
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    documentVersion?: RESTCopyToFoldersDocumentVersionEnum;
    /**
     * Specifies the action that will be performed with the last version of the copied OneDrive document on the destination server.
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    documentLastVersionAction?: RESTCopyToFoldersDocumentLastVersionActionEnum;
    /**
     * Specifies the authentication code. For more information on how to get a device code, see [Get Device Code](#tag/RestoreSession/operation/RestoreSession_DeviceCodeAction). This property is required if you want to use a device code for data restore. 
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    userCode?: string;
    /**
     * Specifies the ID of the Micrisoft Entra application that you want to use for restore.
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    applicationId?: string | null;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    applicationCertificatePassword?: string;
    /**
     * Specifies the SSL certificate configured for the Microsoft Entra application that you want to use for data restore. You must provide the certificate as a Base64 string.
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    applicationCertificate?: string;
    /**
     * Specifies the user name that you want to use for authenticating to the organization.
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    userName?: string;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    userPassword?: string;
    /**
     * Specifies the region of the target Microsoft 365 organization.
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    officeRegion?: RESTCopyToFoldersOfficeRegionEnum;
    /**
     * Specifies the name of the target Microsoft 365 organization.
     * @type {string}
     * @memberof RESTCopyToFolders
     */
    organizationName?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTCopyToFoldersDocumentVersionEnum {
    All = 'All',
    Last = 'Last'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTCopyToFoldersDocumentLastVersionActionEnum {
    Overwrite = 'Overwrite',
    Merge = 'Merge'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTCopyToFoldersOfficeRegionEnum {
    Worldwide = 'Worldwide',
    Germany = 'Germany',
    China = 'China',
    UsDefence = 'USDefence',
    UsGovernment = 'USGovernment'
}

